/**
 * Maps a category/collection page slug to the value stored in Algolia's
 * `categories` facet. Collection slugs use `collections/{name}` in URLs but
 * Algolia stores them without the slash (e.g. `collectionscarin`).
 */
export const getAlgoliaCategoryFilterSlug = slug => {
  if (!slug) return slug;

  if (slug.startsWith('collections/')) {
    return slug.replace('/', '');
  }

  return slug;
};

/** Maps Alexandria filter ids (camelCase) to Algolia facet attribute names. */
export const getAlgoliaFacetAttribute = filterId =>
  filterId ? filterId.toLowerCase() : filterId;

export const isCollectionPageSlug = slug =>
  typeof slug === 'string' && slug.startsWith('collections/');
